<template>
    <div class="content-wrap">
        <Row>
            <Col class="left-wrap width1">
            <div class="title">
                <Icon type="ios-key" class="icon-style" />
                <title-text :inline="true" :onlyText="false">{{
                    curItemObj ? curItemObj.dataName : '-'
                }}</title-text>
            </div>
            <div v-if="isEdit" class="select-list-wrap">
                <div class="operate-wrap">
                    <Select
                        v-model="checkedDBVal"
                        filterable
                        clearable
                        placeholder="请选择库名"
                        class="select-wrap"
                        @on-change="handleChangeSelect"
                    >
                        <Option
                            v-for="item in dbList"
                            :value="item.id"
                            :key="item.id"
                        >{{ item.name }}</Option
                        >
                    </Select>
                    <Input
                        search
                        clearable
                        v-model="searchVal"
                        @blur="queryData"
                        @input="queryData"
                        placeholder="请输入表名"
                        class="input-wrap"
                    />
                </div>
                <div class="all-clear">
                    <div
                        class="icon-font-wrap"
                        :class="{ checked: checkAll }"
                        @click="checkAllData()"
                    >
                        <Icon type="ios-browsers" class="icon-comm" />
                        <div class="checked-all font-style">全选</div>
                    </div>
                    <div
                        class="icon-font-wrap"
                        :class="{ checked: checkClear }"
                        @click="clearAllData()"
                    >
                        <Icon type="ios-trash" class="icon-comm" />
                        <div class="checked-clear font-style">清空</div>
                    </div>
                </div>
                <div class="tables-wrap scrollbar">
                    <div
                        v-for="(item, index) in tableList.slice(0,renderLength)"
                        :key="`${item.name}-${index}`"
                        @click="handleTableItem(item)"
                        class="margin-tb-10 card-block margin-left-20 cursor-point"
                        :class="item.checked ? 'hot-block' : ''"
                        :title="item.name"
                    >
                        {{ item.name }}
                        <div
                            v-if="item.checked"
                            class="tip-group"
                        >
                            <div class="triangle">
                                <Icon
                                    type="md-checkmark"
                                    size="16"
                                    class="icon"
                                ></Icon>
                            </div>
                        </div>
                    </div>
                    <div v-if="tableList.length === 0" class="img-wrap1">
                        <div class="img-content">
                            <img
                                :src="require('./../../../../assets/noData.png')"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
                <div
                    v-if="tableList.length !== renderLength &&tableList.length !== 0&&tableList.length>50"
                    @click="changeTableListData"
                    class="more-wrap"
                >
                    <span>{{ moreDataLabel }}</span>
                </div>

            </div>
            <div v-else-if="!isEdit" class="select-list-wrap">
                <div class="operate-wrap">
                    <Select
                        v-model="checkedDBVal"
                        filterable
                        clearable
                        disabled
                        placeholder="请选择库名"
                        class="select-wrap"
                        @on-change="handleChangeSelect"
                    >
                        <Option
                            v-for="item in dbList"
                            :value="item.id"
                            :key="item.id"
                        >{{ item.name }}</Option
                        >
                    </Select>
                </div>
                <div class="tables-wrap scrollbar">
                    <div
                        v-for="(item, index) in tableList"
                        :key="`${item.name}-${index}`"
                        class="margin-tb-10 card-block margin-left-20 cursor-point"
                        :class="item.checked ? 'hot-block' : ''"
                        :title="item.name"
                    >
                        {{ item.name }}
                        <div
                            v-if="item.checked"
                            class="tip-group"
                        >
                            <div class="triangle">
                                <Icon
                                    type="md-checkmark"
                                    size="16"
                                    class="icon"
                                ></Icon>
                            </div>
                        </div>
                    </div>
                    <div v-if="tableList.length === 0" class="img-wrap1">
                        <div class="img-content">
                            <img
                                :src="require('./../../../../assets/noData.png')"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
                <div
                    v-if="tableList.length !== renderLength &&tableList.length !== 0&&tableList.length>50"
                    @click="changeTableListData"
                    class="more-wrap"
                >
                    <span>{{ moreDataLabel }}</span>
                </div>

            </div>
            <div v-else-if="tableList.length === 0" class="img-wrap1">
                <div class="img-content">
                    <img
                        :src="require('./../../../../assets/noData.png')"
                        alt=""
                    />
                </div>
            </div>
            </Col>

        </Row>
    </div>
</template>

<script>
import requestMix from '../../mix/requestMix'

export default {
    mixins: [requestMix],
    name: 'resourceField',
    props: ['initDataObj', 'selectData', 'isEdit', 'curItemObj', 'selectedAppId', 'selectedRole'],
    data() {
        return {
            checkAll: false,
            checkClear: false,
            checkedDBVal: '',
            searchVal: '',
            dbList: [],
            tableList: [],
            tableListAll: [],
            renderLength: 50,
            renderLengthMore: 50,
            activedIndex: '',
            moreDataLabel: '<<< 更多',
        }
    },
    watch: {
        // 监听isEdit, selectData
        listenIsEditAndSelectData: {
            handler() {
                if (!this.isEdit && this.selectData && this.selectData.resourceField && this.selectData.resourceField.length) {
                    this.tableList = this.selectData.resourceField
                    this.checkedDBVal = this.selectData.resourceField[0].parentId
                } else if (this.checkedDBVal) {
                    this.getTablesByDBInfo(this.checkedDBVal).then((res) => {
                        console.log('res', res)
                        this.recoverTableData()
                    })
                } else {
                    this.tableList = []
                }
            },
            immediate: true
        }
    },
    computed: {
        listenIsEditAndSelectData() {
            console.log('listenChangeData')
            const { isEdit } = this
            const { selectData } = this
            return { isEdit, selectData }
        },
    },
    created() {},
    mounted() {
        this.getTablesByDBInfo(0)
    },
    methods: {
        // 编辑状态表回显
        recoverTableData() {
            if (this.selectData && this.selectData.resourceField && this.selectData.resourceField.length) {
                this.selectData.resourceField.forEach((el) => {
                    const obj = this.tableList.find((item) => item.id === el.id)
                    this.$set(obj, 'checked', true)
                });
            }
        },
        handleChangeSelect(val) {
            this.getTablesByDBInfo(val)
        },
        handleTableItem(item) {
            this.$set(item, 'checked', !item.checked)
            this.getCheckedData()
        },
        // 获取选中的数据
        getCheckedData() {
            const checkedArr = this.tableList.filter((el) => el.checked === true)
            this.initDataObj.RESOURCES_FIELD = checkedArr
            console.log('this.initDataObj.RESOURCES_FIELD', this.initDataObj.RESOURCES_FIELD)
        },
        checkAllData() {
            this.tableList.forEach((el) => {
                this.$set(el, 'checked', true)
            });
            this.checkAll = true
            this.checkClear = false
            this.initDataObj.RESOURCES_FIELD = this.tableList
            this.renderLength = this.tableListAll.length
            this.renderLengthMore = this.renderLength// 备份用
        },
        clearAllData() {
            this.tableList.forEach((el) => {
                this.$set(el, 'checked', false)
            });
            this.checkAll = false
            this.checkClear = false
            this.initDataObj.RESOURCES_FIELD = []
            this.renderLength = this.tableListAll.length
            this.renderLengthMore = this.renderLength// 备份用
        },
        queryData() {
            if (this.searchVal === '' || this.searchVal === null) {
                this.tableList = this.tableListAll
                this.renderLength = this.renderLengthMore
                return;
            }
            const searchArr = this.tableList.filter((item) => item.name.indexOf(this.searchVal) >= 0)
            this.tableList = searchArr
            this.renderLength = searchArr.length
        },
        changeTableListData() {
            this.renderLength = this.tableList.length + 50
            if (this.renderLength >= this.tableList.length) {
                this.renderLength = this.tableList.length
            }
            this.renderLengthMore = this.renderLength// 备份用
        },

    }
}
</script>

<style lang='less' scoped>
.tag {
    display: inline-block;
}
.margin-left-20 {
    margin-left: 20px;
}
.content-wrap {
    background: var(--bg-color);
    height: 100%;

    /deep/ .ivu-row {
        .left-wrap {
            float: left;
            height: 100%;
            background-color: var(--comp-block-bg-color);

            .title {
                height: 29px;
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: var(--base-font-color);
                line-height: 29px;
                .icon-style {
                    margin-right: 5px;
                }
            }
            .img-wrap1 {
                height: calc(100% - 40px);
                .img-content {
                    display: flex;
                    height: 100%;
                    justify-content: center;
                    align-items: center;
                }
            }
            .select-list-wrap {
                height: calc(100% - 30px);
                padding-right: 10px;
                .operate-wrap {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-top: 20px;
                    padding-bottom: 15px;
                    .select-wrap {
                        width: 45%;
                    }
                    .input-wrap {
                        margin-right: 10px;
                        width: 45%;
                    }
                }
                .all-clear {
                    display: flex;
                    align-items: center;
                    .icon-font-wrap {
                        display: flex;
                        align-items: center;
                        margin-right: 27px;
                        .font-style {
                            cursor: pointer;
                            font-size: 16px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            line-height: 22px;
                        }
                        .icon-comm {
                            font-size: 16px;
                            padding-right: 5px;
                        }
                    }
                    .checked {
                        color: var(--comp-selected-color) !important;
                    }
                }
                .tables-wrap {
                    width: 100%;
                    height: 58.5vh;
                    .hot-block {
                        border: 1px solid var(--comp-selected-color) !important;
                    }
                    .card-block {
                        border-radius: 4px;
                        border: 1px solid var(--divider-color);
                        padding: 10px;
                        position: relative;
                        width: 28%;
                        display: inline-block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
                .more-wrap {
                    width: 100px;
                    position: absolute;
                    right: 10px;
                    bottom: 25px;
                    cursor: pointer;
                }
                .tip-group {
                    position: absolute;
                    right: 0;
                    bottom: -5px;
                    .triangle {
                        width: 0;
                        height: 0;
                        border-right: 36px solid var(--comp-selected-color);
                        border-left: 10px solid transparent;
                        border-top: 20px solid transparent;
                        display: inline-block;
                    }
                    .icon {
                        position: absolute;
                        top: 4px;
                        right: 0;
                        bottom: 0;
                        color: white;
                    }
                }
            }
        }
        .width1 {
            width: 100%;
        }
        .width2 {
            width: 50%;
        }
    }
}
</style>
